import { render, staticRenderFns } from "./DescuentoTratamiento.vue?vue&type=template&id=5d881a13&scoped=true"
import script from "./DescuentoTratamiento.vue?vue&type=script&lang=js"
export * from "./DescuentoTratamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d881a13",
  null
  
)

export default component.exports